<div class="thp-form-container">
  <div class="thp-form">
  <form [formGroup]="authorizationForm" class="authorization-form">
    <label class="thp-header">{{"talent-happy-path.talent-profile.authorization-page.title" | translate}}</label>
    <div class="field-group">
      <label class="field-label" id="work-authorization-radio-group-label">{{"talent-happy-path.talent-profile.authorization-page.authorized-in-location" | translate}}<span *ngIf="country">: {{countryName}}?</span></label>
      <mat-radio-group aria-labelledby="work-authorization-radio-group-label" class="authorization-radio-group" formControlName="workAuthorization">
        <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="field-group">
      <label class="field-label" id="immigration-radio-group-label">{{"talent-happy-path.talent-profile.authorization-page.sponsorship" | translate}}</label>
      <mat-radio-group aria-labelledby="immigration-radio-group-label" class="authorization-radio-group" formControlName="requireImmigrationSponsorship">
        <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
  </div>
  <div class="navigation-buttons">
    <button mat-stroked-button color="primary" class="back-btn" (click)="goToEmploymentSalary()"><mat-icon>arrow_back</mat-icon> {{"talent-happy-path.buttons.back" | translate}}</button>
    <button mat-flat-button color="primary" class="next-btn" (click)="goToTalentEeocOrThankYou()"><mat-icon>arrow_forward</mat-icon>{{"talent-happy-path.buttons.next" | translate}}</button>
  </div>
  <div class="button-container">
    <button mat-button class="later-button" (click)="isModalVisible = true" *ngIf="!fromNotAFit">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
